/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable camelcase */
import api from './api';

class Services {

  postContato = (data: any) => {
    return api.post(`/core/contato-setra/`, data);
  };

  getMedias = () => {
    return api.get(`/core/medias-setra/`);
  };

}
export default Services;
